import useSiteConfig from './use-site-config';

export default useSiteConfig;